module.exports = __webpack_public_path__ + "img/gift3.2be0f1ca.png";